import React from "react";
import { Link } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { RiMedicineBottleLine } from "react-icons/ri";

const POPULAR_SEARCHES = [
  { name: "Cialis", query: "Cialis" },
  { name: "Lipitor", query: "Lipitor" },
  { name: "Metformin", query: "Metformin" },
  { name: "Aspirin", query: "Aspirin" },
  { name: "Omeprazole", query: "Omeprazole" },
];

export default function NoResults({
  searchQuery = "",
  message = "No matches found. Try a different spelling or search for the brand name instead of the generic."
}) {
  return (
    <div className="flex flex-col items-center justify-center p-8 mt-6 text-center">
      <div className="flex items-center justify-center size-16 rounded-2xl bg-secondary/5">
        <FiSearch className="size-7 text-secondary/40" />
      </div>

      <h3 className="mt-5 font-semibold text-20 text-secondary">
        No results found
      </h3>

      <p className="mt-2 text-16 font-text text-secondary/80 max-w-[500px] leading-relaxed">
        {searchQuery ? (
          <>
            We couldn't find anything for <span className="font-medium text-primary">"{searchQuery}"</span>.
          </>
        ) : (
          message
        )}
      </p>

      {/* Actionable suggestions */}
      <div className="mt-5 p-5 rounded-xl bg-white border border-secondary/8 max-w-[500px] w-full text-left">
        <p className="text-16 font-text font-medium text-secondary mb-3">
          Try these tips:
        </p>
        <ul className="space-y-2 text-16 font-text text-secondary/80">
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            Check the spelling of the medicine name
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            Search for the brand name (e.g. "Lipitor" instead of "atorvastatin")
          </li>
          <li className="flex items-start gap-2">
            <span className="text-primary mt-0.5">•</span>
            Use a simpler term (e.g. "blood pressure" or "cholesterol")
          </li>
        </ul>
      </div>

      {/* Popular medications */}
      <div className="mt-6 max-w-[500px] w-full">
        <p className="text-14 font-text font-medium text-secondary/70 mb-3">
          Or try one of these popular searches:
        </p>
        <div className="flex flex-wrap gap-2 justify-center">
          {POPULAR_SEARCHES.map((item) => (
            <Link
              key={item.name}
              to={`/search?q=${encodeURIComponent(item.query)}&type=all&page=1`}
              className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-full text-14 font-text font-medium text-secondary/80 bg-white border border-secondary/10 hover:border-primary/30 hover:text-primary transition-colors min-h-[44px]"
            >
              <RiMedicineBottleLine className="size-4" />
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
